<div class="cowing-input-container">
  <div class="cowing-input-container">
    <div *ngIf="!isForm" class="image-general-container" [attr.for]="name">
      <input [id]="name" [type]="'file'" [attr.accept]="acceptPhoto ? 'image/*' : 'video/mp4'" [(ngModel)]="value"
        (input)="onInputChange($event)" />
      <div class="image-container">
        <span>
          <img [src]="getIcon" alt="" />
        </span>
      </div>
    </div>

    <label *ngIf="isForm" class="image-general-container" [attr.for]="name" [ngClass]="inputStyle">
      <div *ngIf="!acceptPhoto && control.value" class="btn-delete-video" (click)="deleteVideo()">
        <img [src]="getCloseIcon" />
      </div>
      <input [id]="name" [type]="'file'" [attr.accept]="acceptPhoto ? 'image/*' : 'video/mp4'"
        (change)="handleFileInput($event)" />
      <div class="image-container" *ngIf="!control.value || url === 'qwert'">
        <span>
          <img [src]="getIcon" alt="" />
        </span>
      </div>

      <div class="image-wrapper" *ngIf="control.value && url && url !== 'qwert'">
        <label [attr.for]="name">
          <img *ngIf="acceptPhoto" [src]="url" [ngClass]="inputStyle" />
          <video *ngIf="!acceptPhoto" [src]="url" controls></video>
        </label>
      </div>
    </label>
  </div>
</div>